import { useState } from 'react';

import { Modal } from '@components';
import DatePicker from '@components/date-picker/DatePicker';
import Input from '@components/input/Input';
import Label from '@components/label/Label';
import { formatISODate } from '@utils/date';

interface CalendarInputProps {
  selectedDate?: Date;
  handleDateChange: (date?: Date) => void;
  label?: string;
  placeholder?: string;
  className?: string;
  inputStyle?: string;
  labelStyle?: string;
  disabled?: boolean;
  isRequired?: boolean;
  minDate?: Date;
  maxDate?: Date;
  isMinDateRequired?: boolean;
  isMaxDateRequired?: boolean;
  modalTitle?: string;
  modalTitleStyle?: string;
  onClearEndDate?: () => void;
}

const CalendarInput = ({
  selectedDate,
  handleDateChange,
  label,
  placeholder = 'Select Date',
  className,
  inputStyle,
  labelStyle,
  disabled = false,
  isRequired = false,
  minDate,
  maxDate = new Date(),
  isMinDateRequired = false,
  isMaxDateRequired = true,
  modalTitle = 'Select Date',
  modalTitleStyle,
  onClearEndDate
}: CalendarInputProps) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleInputClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (!disabled) {
      setIsCalendarOpen(true);
    }
  };

  const handleCancel = () => {
    setIsCalendarOpen(false);
  };

  const handleConfirm = (date?: Date) => {
    setIsCalendarOpen(false);
    handleDateChange(date);
  };

  return (
    <div className={`relative ${className}`}>
      {label && (
        <Label label={label} className={labelStyle} isRequired={isRequired} />
      )}
      <Input
        disabled={disabled}
        onClearIconAction={onClearEndDate}
        leftIconName="calendar"
        value={selectedDate ? formatISODate({ date: selectedDate }) : ''}
        placeholder={placeholder}
        onClick={handleInputClick}
        readOnly
        inputStyle={`text-grey cursor-pointer ${inputStyle}`}
      />
      {isCalendarOpen && (
        <Modal isOpen={isCalendarOpen} onCancel={handleCancel}>
          <div className=" overflow-hidden rounded-lg bg-white shadow-lg">
            <DatePicker
              title={modalTitle}
              titleStyle={`text-sm font-medium ${modalTitleStyle}`}
              minDate={minDate}
              maxDate={maxDate}
              confirmButtonLabel="Apply"
              confirmButtonStyle="text-primary text-sm"
              handleConfirm={handleConfirm}
              cancelButtonLabel="Cancel"
              handleCancel={handleCancel}
              isMinDateRequired={isMinDateRequired}
              isMaxDateRequired={isMaxDateRequired}
              selectedDate={selectedDate}
              calendarStyle="!bg-white !text-xs origin-top"
              className="flex h-full flex-col !p-3"
              buttonStyles="!text-sm "
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default CalendarInput;
